import { normalizeFavoriteStoreId } from './normalizeFavoriteStoreId'

export const getFavoriteStoreIds = (stores: { id?: string | number }[]): number[] =>
  stores.flatMap((store) => {
    const storeId = normalizeFavoriteStoreId(store.id)
    return storeId === null ? [] : [storeId]
  })
